import React, { useState } from "react";
import PropTypes from "prop-types";
import InputText from "components/atoms/InputText";
import Icon from "components/atoms/Icon";
import classnames from "classnames";

const InputSearchField = ({
  className,
  filterText,
  noSubmitOnEnter,
  onFilterTextInput,
}) => {
  const [iconType, setIconType] = useState(
    filterText ? "Schliessen" : "Suchen",
  );

  const handleFilterTextInputChange = (e) => {
    const value = e.target.value;
    onFilterTextInput(value);
    setIconType(value ? "Schliessen" : "Suchen");
  };

  const handleIconClick = () => {
    handleFilterTextInputChange({ target: { value: "" } });
  };

  const preventFormSubmitOnEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const componentBaseClass = "sal-input-searchfield";
  const componentClassName = classnames(componentBaseClass, className);

  return (
    <div className={componentClassName}>
      <InputText
        className={`${componentBaseClass}__input`}
        type="text"
        name="searchFilter"
        value={filterText}
        placeholder="Filtersuche"
        onChange={handleFilterTextInputChange}
        onKeyDown={noSubmitOnEnter ? preventFormSubmitOnEnter : null}
      />
      <Icon
        className={`${componentBaseClass}__icon`}
        type={iconType}
        onClick={handleIconClick}
      />
    </div>
  );
};

InputSearchField.propTypes = {
  className: PropTypes.string,
  filterText: PropTypes.string.isRequired,
  noSubmitOnEnter: PropTypes.bool,
  onFilterTextInput: PropTypes.func.isRequired,
};

export default InputSearchField;
